/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiEmployeesIdCvRevertRequestMutationResponse,
  PostApiEmployeesIdCvRevertRequestPathParams,
} from '../models/PostApiEmployeesIdCvRevertRequest.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { postApiEmployeesIdCvRevertRequestMutationResponseSchema } from '../zod/postApiEmployeesIdCvRevertRequestSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiEmployeesIdCvRevertRequestMutationKey = () =>
  [{ url: '/api/employees/:id/cv/revert-request' }] as const;

export type PostApiEmployeesIdCvRevertRequestMutationKey = ReturnType<
  typeof postApiEmployeesIdCvRevertRequestMutationKey
>;

/**
 * {@link /api/employees/:id/cv/revert-request}
 */
export async function postApiEmployeesIdCvRevertRequest(
  id: PostApiEmployeesIdCvRevertRequestPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiEmployeesIdCvRevertRequestMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'POST',
    url: `/api/employees/${id}/cv/revert-request`,
    ...requestConfig,
  });
  return postApiEmployeesIdCvRevertRequestMutationResponseSchema.parse(
    res.data,
  );
}

/**
 * {@link /api/employees/:id/cv/revert-request}
 */
export function usePostApiEmployeesIdCvRevertRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiEmployeesIdCvRevertRequestMutationResponse,
      ResponseErrorConfig<Error>,
      { id: PostApiEmployeesIdCvRevertRequestPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiEmployeesIdCvRevertRequestMutationKey();

  return useMutation<
    PostApiEmployeesIdCvRevertRequestMutationResponse,
    ResponseErrorConfig<Error>,
    { id: PostApiEmployeesIdCvRevertRequestPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return postApiEmployeesIdCvRevertRequest(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
